import { createContext, FC, ReactNode, useContext, useMemo } from 'react';
import { UseQueryResult } from 'react-query';
import { AlarmedBoxesResponse, BoxStatusCardData, SensorFilters, TimelineFilters, TimelineResponse } from '../types/sensors';
import { httpPollingTransport } from './HttpPollingTransport';
import { webSocketTransport } from './WebSocketTransport';

export interface SensorTransport {
  useAlarmedBoxes(filters: SensorFilters): UseQueryResult<AlarmedBoxesResponse>;
  useBoxTimeline(box_id: number | null, filters: TimelineFilters): UseQueryResult<TimelineResponse>;
  useBoxStatus(box_id: number | null): UseQueryResult<BoxStatusCardData | null>;
}

const SensorTransportContext = createContext<SensorTransport | null>(null);

type Props = { transport: 'polling' | 'websocket'; children: ReactNode };

export const SensorTransportProvider: FC<Props> = ({ transport, children }) => {
  const impl = useMemo(
    () => (transport === 'websocket' ? webSocketTransport : httpPollingTransport),
    [transport],
  );
  return (
    <SensorTransportContext.Provider value={impl}>
      {children}
    </SensorTransportContext.Provider>
  );
};

export function useSensorTransport(): SensorTransport {
  const ctx = useContext(SensorTransportContext);
  if (!ctx) throw new Error('useSensorTransport must be used inside SensorTransportProvider');
  return ctx;
}
